"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-sidebar app-theme-bg",
    class: [`app-sidebar-section-${_vm.section}`]
  }, [!_vm.sidebarState.isOpen ? _c('span', {
    staticClass: "app-sidebar-options"
  }, [_c('div', {
    staticClass: "app-sidebar-close",
    on: {
      "click": function ($event) {
        return _vm.sidebarState.close();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('close'))), _c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm.sidebarState.activeComponent ? [_c(_vm.sidebarState.activeComponent, _vm._b({
    tag: "component",
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }, 'component', _vm.sidebarState.activeComponentProps, false))] : _vm.buffer ? [_vm.buffer.isChannel() ? [_vm.section === 'settings' && !_vm.sidebarState.isDesktop() ? _c('sidebar-section-settings', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }) : _vm.section === 'nicklist' || (_vm.section === 'user' || _vm.section === 'about' || _vm.section === 'settings') && _vm.sidebarState.isDesktop() ? _c('nicklist', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }) : _vm.section === 'about' ? _c('sidebar-about-buffer', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }) : _vm._e(), _vm.section === 'user' && _vm.sidebarState.isDesktop() ? _c('div', {
    staticClass: "app-userbox-modal",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "app-sidebar-userbox-close",
    attrs: {
      "type": "button",
      "title": _vm.$t('close')
    },
    on: {
      "click": function ($event) {
        return _vm.sidebarState.close();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "app-userbox-modal-scroll"
  }, [_c('user-box', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "user": _vm.sidebarState.sidebarUser,
      "sidebar-state": _vm.sidebarState
    }
  })], 1)]) : _vm.section === 'user' ? _c('div', {
    staticClass: "app-sidebar-userbox",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('user-box', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "user": _vm.sidebarState.sidebarUser,
      "sidebar-state": _vm.sidebarState
    }
  })], 1) : _vm._e(), _vm.section === 'about' && _vm.sidebarState.isDesktop() ? _c('div', {
    staticClass: "app-userbox-modal",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "app-sidebar-userbox-close",
    attrs: {
      "type": "button",
      "title": _vm.$t('close')
    },
    on: {
      "click": function ($event) {
        return _vm.sidebarState.close();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "app-userbox-modal-scroll"
  }, [_c('sidebar-about-buffer', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  })], 1)]) : _vm._e(), _vm.section === 'settings' && _vm.sidebarState.isDesktop() ? _c('div', {
    staticClass: "app-userbox-modal app-userbox-modal--settings",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "app-sidebar-userbox-close",
    attrs: {
      "type": "button",
      "title": _vm.$t('close')
    },
    on: {
      "click": function ($event) {
        return _vm.sidebarState.close();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "app-userbox-modal-scroll"
  }, [_c('sidebar-section-settings', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  })], 1)]) : _vm._e()] : _vm.buffer.isQuery() ? [_vm.section === 'user' ? _c('div', {
    staticClass: "app-sidebar-userbox",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('user-box', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "user": _vm.sidebarState.sidebarUser,
      "sidebar-state": _vm.sidebarState
    }
  })], 1) : _vm._e()] : _vm._e()] : [_vm._v(" " + _vm._s(_vm.$t('side_buffer')) + " ")]], 2);
};
var staticRenderFns = exports.staticRenderFns = [];